import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import mapStrings from '../misc/strings';

Vue.use(Router);

const importer = path => import(`../views/${path}.vue`);
const strings = mapStrings.mapStrings;

const router = new Router({
  // sayfa değiştirirken gidecek olan sayfadaki pozisyonu ayarlar
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => importer('DashboardLayout'),
      redirect: '/dashboard',
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          meta: { bookmark: strings.dashboard },
          component: () => importer('Pages/Dashboard'),
        },
        {
          path: '/birthday/template',
          name: 'birthday.index',
          meta: { bookmark: strings.birthday },
          component: () => importer('Pages/Template/Birthday/Index'),
        },
        {
          path: '/user/sub/users',
          name: 'user.sub.index',
          meta: { bookmark: strings.subUser },
          component: () => importer('Pages/User/SubUser/Index'),
        },
        {
          path: '/user/sub/:id/settings',
          name: 'user.sub.settings',
          component: () => importer('Pages/User/SubUser/Settings'),
        },
        {
          path: '/user/settings',
          name: 'settings.index',
          meta: { bookmark: strings.settings },
          component: () => importer('Pages/Settings/Index'),
        },
        {
          path: '/bank/accounts',
          name: 'bank.accounts.index',
          meta: { bookmark: strings.bank },
          component: () => importer('Pages/BankAccounts/Index'),
        },
        {
          path: '/template/sms/create',
          name: 'template.sms.create',
          meta: { bookmark: strings.templateCreate },
          component: () => importer('Pages/Template/Create'),
        },
        {
          path: '/template/sms/update/:id',
          name: 'template.sms.update',
          meta: { bookmark: strings.templateUpdate },
          component: () => importer('Pages/Template/Update'),
        },
        {
          path: '/template/sms/list',
          name: 'template.sms.index',
          meta: { bookmark: strings.template },
          component: () => importer('Pages/Template/Index'),
        },
        {
          path: '/group/contacts/list',
          name: 'group.contacts.index',
          meta: { bookmark: strings.groupContacts },
          component: () => importer('Pages/Group/Index'),
        },
        {
          path: '/group/list',
          name: 'group.index',
          meta: { bookmark: strings.groups },
          component: () => importer('Pages/Group/OnlyGroup'),
        },
        {
          path: '/group/duplicates/:id',
          name: 'group.duplicates',
          meta: { bookmark: strings.groups },
          props: route => ({ ...route.params }),
          component: () => importer('Pages/Group/Duplicates'),
        },
        {
          path: '/sms/send/number/:phone?',
          name: 'sms.send.number',
          meta: { bookmark: strings.smsOne },
          component: () => importer('Pages/Sms/Number'),
        },
        {
          path: '/sms/send/bulk/excel',
          name: 'sms.bulk.excel',
          meta: { bookmark: strings.smsExcel },
          component: () => importer('Pages/Sms/Bulk/Excel'),
        },
        {
          path: '/sms/send/special/excel',
          name: 'sms.special.excel',
          meta: { bookmark: strings.smsSpecialExcel },
          component: () => importer('Pages/Sms/Bulk/AdvancedExcel'),
        },
        {
          path: '/sms/group/send',
          name: 'sms.group.index',
          meta: { bookmark: strings.smsGroup },
          component: () => importer('Pages/Sms/Index'),
        },
        {
          path: '/sms/group/send/bulk/number',
          name: 'sms.group.bulk_number',
          props: {},
          component: () => importer('Pages/Sms/Bulk/Number'),
        },
        {
          path: '/sms/group/send/selective',
          name: 'sms.group.selective',
          meta: { bookmark: strings.smsSelective },
          component: () => importer('Pages/Sms/Bulk/Selective'),
        },
        {
          path: '/whatsapp/group/send',
          name: 'whatsapp.group.index',
          meta: { bookmark: strings.whatsappGroup },
          component: () => importer('Pages/Whatsapp/Index'),
        },
        {
          path: '/whatsapp/send/bulk/excel',
          name: 'whatsapp.bulk.excel',
          meta: { bookmark: strings.whatsappExcel },
          component: () => importer('Pages/Whatsapp/Bulk/Excel'),
        },
        {
          path: '/whatsapp/send/special/excel',
          name: 'whatsapp.special.excel',
          meta: { bookmark: strings.whatsappSpecialExcel },
          component: () => importer('Pages/Whatsapp/Bulk/AdvancedExcel'),
        },
        {
          path: '/whatsapp/group/send/bulk/number',
          name: 'whatsapp.group.bulk_number',
          meta: { bookmark: strings.whatsappBulk },
          props: {},
          component: () => importer('Pages/Whatsapp/Bulk/Number'),
        },
        {
          path: '/whatsapp/group/send/selective',
          name: 'whatsapp.group.selective',
          meta: { bookmark: strings.whatsappSelective },
          component: () => importer('Pages/Whatsapp/Bulk/Selective'),
        },
        {
          path: '/whatsapp/send/number/:phone?',
          name: 'whatsapp.send.number',
          meta: { bookmark: strings.whatsappOne },
          component: () => importer('Pages/Whatsapp/Number'),
        },
        {
          path: '/whatsapp/prices',
          name: 'whatsapp.prices.index',
          meta: { bookmark: strings.whatsappPrices },
          component: () => importer('Pages/Whatsapp/Prices'),
        },
        {
          path: '/whatsapp/reports',
          name: 'whatsapp.reports.index',
          meta: { bookmark: strings.whatsappReports },
          props: route => ({ ...route.params }),
          component: () => importer('Pages/Whatsapp/Reports'),
        },
        {
          path: '/whatsapp/report/detail/:id',
          name: 'whatsapp.report.detail',
          meta: { bookmark: strings.whatsappReportDetail },
          props: route => ({ ...route.params }),
          component: () => importer('Pages/Whatsapp/ReportDetail'),
        },
        {
          path: '/whatsapp/report/search',
          name: 'whatsapp.report.search',
          meta: { bookmark: strings.whatsappReportSearch },
          component: () => importer('Pages/Whatsapp/ReportSearch'),
        },
        {
          path: '/whatsapp/documentation',
          name: 'whatsapp.documentation.index',
          meta: { bookmark: strings.documentation },
          component: () => importer('Pages/Whatsapp/Documentation'),
        },
        {
          path: '/whatsapp/settings',
          name: 'whatsapp.settings',
          meta: { bookmark: strings.whatsappSettings },
          component: () => importer('Pages/Whatsapp/Settings'),
        },
        {
          path: '/contact/create',
          name: 'contact.create',
          meta: { bookmark: strings.contactCreate },
          component: () => importer('Pages/Contact/Create'),
        },
        {
          path: "/contact/list",
          name: "contact.list",
          meta: { bookmark: strings.contactList },
          component: () => importer("Pages/Contact/List"),
        },
        {
          path: '/contact/detail/:id',
          name: 'contact.detail',
          props: {},
          meta: { bookmark: strings.contactDetail },
          component: () => importer('Pages/Contact/Detail'),
        },
        {
          path: '/blacklist/all',
          name: 'blacklist.index',
          meta: { bookmark: strings.blacklist },
          component: () => importer('Pages/BlackList/Index'),
        },
        {
          path: '/payments/all',
          name: 'payments.index',
          meta: { bookmark: strings.payment },
          component: () => importer('Pages/Payments/Index'),
        },
        {
          path: '/payments/notify',
          name: 'payments.notify',
          meta: { bookmark: strings.paymentNotify },
          component: () => importer('Pages/Payments/Notify'),
        },
        {
          path: '/whatsapp/payments/card',
          name: 'whatsapp.payments.card',
          meta: { bookmark: strings.payment },
          props: true,
          component: () => importer('Pages/Payments/WhatsappCard'),
        }, // payments.card
        {
          path: '/prices/all',
          name: 'prices.index',
          meta: { bookmark: strings.prices },
          component: () => importer('Pages/Prices/Index'),
        },
        {
          path: '/other-projects',
          name: 'projects.index',
          meta: { bookmark: strings.projects },
          component: () => importer('Pages/Project/Index'),
        },
        {
          path: '/sender/all',
          name: 'sender.index',
          meta: { bookmark: strings.sender },
          component: () => importer('Pages/Sender/Index'),
        },
        {
          path: '/report/all/xadmin',
          name: 'report.xadmin.index',
          meta: { bookmark: strings.xadmin },
          props: route => ({ ...route.params }),
          component: () => importer('Pages/Report/XAdmin/Index'),
        },
        {
          path: '/report/all',
          name: 'report.index',
          meta: { bookmark: strings.report },
          props: route => ({ ...route.params }),
          component: () => importer('Pages/Report/Index'),
        },
        {
          path: '/report/search',
          name: 'report.search',
          meta: { bookmark: strings.reportSearch },
          component: () => importer('Pages/Report/Search'),
        },
        {
          path: '/report/incoming',
          name: 'report.incoming',
          meta: { bookmark: strings.incoming },
          component: () => importer('Pages/Report/Incoming'),
        },
        {
          path: '/report/detail/:id',
          name: 'report.detail',
          meta: { bookmark: strings.reportDetail },
          props: route => ({ ...route.params }),
          component: () => importer('Pages/Report/Detail'),
        },
        {
          path: '/cancel/all',
          name: 'cancel.index',
          meta: { bookmark: strings.cancel },
          component: () => importer('Pages/Cancel/Index'),
        },
        {
          path: '/notifications',
          name: 'notifications.index',
          meta: { bookmark: strings.notifications },
          component: () => importer('Pages/Notifications/Index'),
        },
        {
          path: '/iys/report',
          name: 'iys.report',
          meta: { bookmark: strings.iysReport },
          component: () => importer('Pages/Iys/Report'),
        },
        {
          path: '/iys/query',
          name: 'iys.permission_query',
          meta: { bookmark: strings.iysQuery },
          component: () => importer('Pages/Iys/PermissionQuery'),
        },
        {
          path: '/iys/permission/add',
          name: 'iys.permission.add',
          meta: { bookmark: strings.iysPermissionAdd },
          component: () => importer('Pages/Iys/Permission'),
        },
        {
          path: '/iys/permission/excel-add',
          name: 'iys.permission.excel_add',
          meta: { bookmark: strings.iysExcel },
          component: () => importer('Pages/Iys/ExcelPermission'),
        },
        {
          path: '/iys/blocked/list',
          name: 'iys.blocked_list',
          meta: { bookmark: strings.iysBlockedList },
          component: () => importer('Pages/Iys/BlockedList'),
        },
        {
          path: '/iys/blocked/detail/:id',
          name: 'iys.blocked_detail',
          meta: { bookmark: strings.iysBlockedDetail },
          component: () => importer('Pages/Iys/BlockedDetail'),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      meta: { ifNotLogged: true },
      component: () => importer('Auth/Login'),
    },
    {
      path: '/login/redirect',
      name: 'login.redirect',
      params: { us: {} },
      meta: { ifNotLogged: true, some: {} },
      component: () => importer('Auth/Login'),
    },
    {
      path: "/login/selection",
      name: "selection",
      meta: { ifNotLogged: true },
      component: () => importer("Auth/Selection"),
    },
    {
      path: '/login/2fa',
      name: '2fa',
      meta: { ifNotLogged: true },
      component: () => importer('Auth/2FA'),
    },
    {
      path: '/protected/login',
      name: 'protected.login',
      component: () => import('../views/Components/AutoLogin.vue'),
    },
    {
      path: '/register',
      name: 'register',
      meta: { ifNotLogged: true },
      component: () => importer('Auth/Register'),
    },
    {
      path: '/reset/password',
      name: 'reset.password',
      meta: { ifNotLogged: true },
      component: () => importer('Auth/Forgot'),
    },
    {
      path: '/cancel/link/:id',
      name: 'cancel.link',
      meta: { requiresAuth: false, ifNotLogged: true },
      component: () => importer('CancelLink/Index'),
    },
    {
      path: '/connection/lose',
      name: 'connection',
      meta: { requiresAuth: false },
      component: () => import('../views/Components/NoConnection'),
    },
  ],
});

// Her route girmeden(çalışmadan önce burası aktif oluyor)
router.beforeEach((to, from, next) => {
  to.matched.some((record) => {
    if (record.name === 'protected.login') {
      store.state.twoFA.state = true;
    }
    return true;
  });

  // Kullanıcı adı aktif değisle route'a geçişi engeller
  if (to.matched.some(record => record.meta.requiresActiveSender)) {
    // eslint-disable-next-line global-require
    require('../middleware/requires-active-sender').default(store, next);
  } else {
    next();
  }

  // Gitmeye çalıştığı route un 'requiresAuth' özelliği true ise
  // Kullanıcının giriş yapıp yapmadığını kontrol ediyor.
  // Eğer giriş yapmışsa bırakıyor.
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      const vatanTawk = 'https://embed.tawk.to/57612fc75a78e2816f79cc84/default';
      const zorluTawk = 'https://embed.tawk.to/5e2731d4daaca76c6fcf29e2/default';

      if (store.state.user.site === 'zorlusms') {
        Vue.prototype.$Tawk.$createChat(zorluTawk);
      } else {
        Vue.prototype.$Tawk.$createChat(vatanTawk);
      }
      next();
      return;
    }
    // Eğer yapmamışsa da login'e gönderiyor..
    next('/login');
  } else {
    next();
  }

  // Tıpkı Laravelde olduğu gibi, Eğer kullanıcı giriş yapmışsa ve
  // Hala 'login' veya 'register'a gitmek istiyorsa buna izin vermeyip,
  // /dashboard'a gitmesini sağlıyoruz.
  if (to.matched.some(record => record.meta.ifNotLogged)) {
    if (!store.getters.isLoggedIn) {
      next();
    } else {
      next('/dashboard');
    }
  }
});
export default router;
